import React, { useState, useEffect } from "react";
import "./AppointmentCard.css";
import moment from "moment";

const AppointmentCard = (props) => {
  const [appointmentData, setAppointmentData] = useState({});
  useEffect(() => {
    setAppointmentData(props.cardData);
    // eslint-disable-next-line
  }, [props.appointOpen]);
  return (
    <div className="appointment_detailed">
      <div className="ad_pointer"></div>
      <div className="dash_box_title ad_title">Appointment Details</div>
      {moment(appointmentData.join_time).format() >= moment(new Date()).format() ? (
        <div className="ad_bucket" onClick={(e) => props.openCloseDelete(props.appointId, e)}></div>
      ) : (
        ""
      )}
      <div className="appoint_general_info">
        <div className="appoint_general_top_hold">
          <div className="appoint_name">{appointmentData.username}</div>
          {/*<div className="appointment_new">New Patient</div>*/}
        </div>
        <div className="appoint_general_top_hold">
          <div className="ag_icon ag_icon_clock"></div>
          <div className="ag_text">
            {moment(appointmentData.start_time).format("LT")} -{moment(appointmentData.end_time).format("LT")} &#x2022;{" "}
            {/* {moment(
              new Date(appointmentData.end_time).getTime() - new Date(appointmentData.start_time).getTime()
            ).format("mm")}{" "} */}
            30 min
          </div>
        </div>
        <div className="appoint_general_top_hold">
          <div className="ag_icon ag_icon_cal"></div>
          <div className="ag_text">
            {moment().calendar(props.cardDate).split(" ")[0] === "Today"
              ? moment().calendar(props.cardDate).split(" ")[0] + ", " + moment(props.cardDate).format("LL")
              : moment(props.cardDate).format("dddd, LL")}
          </div>
        </div>
      </div>
      <div className="appoint_pain_info">
        <div className="apcard_title">Pain & Discomfort</div>
        <div className="ag_text apcard_text">{appointmentData.problem_name}</div>
        <div className="ad_pain_dot_hold">
          <div
            className={
              "ad_pain_dot" +
              (appointmentData.pain_level ? " ap_color" + Math.round(appointmentData.pain_level / 2) * 2 : " ap_color0")
            }
          ></div>
          <div className="ag_text">
            {appointmentData.pain_level <= 2 && appointmentData.pain_level > 0
              ? "Mild Pain"
              : appointmentData.pain_level > 2 && appointmentData.pain_level <= 4
              ? "Moderate Pain"
              : appointmentData.pain_level > 4 && appointmentData.pain_level <= 6
              ? "Severe Pain"
              : appointmentData.pain_level > 6 && appointmentData.pain_level <= 8
              ? "Most Severe Pain"
              : appointmentData.pain_level > 8 && appointmentData.pain_level <= 10
              ? "Unbearable Pain"
              : "No Pain"}
          </div>
        </div>
        <div className="apcard_title">What would you like to discuss?</div>
        <div className="ag_text ap_text">{appointmentData.description}</div>
      </div>
      <div className="ad_buttons_hold">
        <div className="ad_button ad_button_cls" onClick={(e) => props.closeAppoint(-1)}>
          Cancel
        </div>
      </div>
    </div>
  );
};

export default AppointmentCard;
